import { NvTableCellProps } from 'shared/components/nv-table';
import { RecruitmentApplication } from 'redux/schemas/models/mentoring-program-recruitments';


export enum ColumnID {
  CHECKBOX = 'checkbox',
  NAME = 'name',
  DATE_SUBMITTED = 'dateSubmitted',
  ADD_BUTTON = 'addButton',
}

export type CellProps = NvTableCellProps<RecruitmentApplication>;
